<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.zsth">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">Bell Type Annealing Furnace</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <img :src="images.zsth2" alt style="white-space:normal;">
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        zsth: require("../../../assets/img/common/zsth.jpg"),
        zsth2: require("../../../assets/img/common/zsth2.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/zsth.vue